module.exports = __webpack_public_path__ + "static/map_spreadsheep-9e62a4cf20497d23b05ff19dc7475879.gif";